import { memo } from 'react';
import type { FlowStats } from '../types';

interface StatsPanelProps {
  stats: FlowStats;
  tareaName?: string;
}

const StatsPanel = memo(({ stats, tareaName }: StatsPanelProps) => {
  return (
    <div
      style={{
        position: 'absolute',
        bottom: 16,
        left: 16,
        zIndex: 10,
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 8,
        padding: '10px 14px',
        fontSize: 12,
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        minWidth: 160,
      }}
    >
      {tareaName && (
        <div
          style={{
            fontWeight: 600,
            color: '#1f2937',
            marginBottom: 8,
            paddingBottom: 8,
            borderBottom: '1px solid #f3f4f6',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: 13,
            maxWidth: 200,
          }}
          title={tareaName}
        >
          {tareaName}
        </div>
      )}

      <div style={{ display: 'flex', gap: 16 }}>
        <StatItem label="Nodos" value={stats.totalNodes} />
        <StatItem label="IA" value={stats.conIA} color="#10b981" />
      </div>
    </div>
  );
});

interface StatItemProps {
  label: string;
  value: number;
  color?: string;
}

function StatItem({ label, value, color }: StatItemProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
      <span style={{ color: '#9ca3af', fontSize: 11 }}>{label}</span>
      <span style={{ fontWeight: 600, color: color || '#1f2937', fontSize: 13 }}>{value}</span>
    </div>
  );
}

StatsPanel.displayName = 'StatsPanel';

export default StatsPanel;
